require('../layout');

$("#projects").find(".button-flotant").on("click", function () {
    $("#projects").find(".search").toggleClass("active");
})

$(".filter-regions .regions").find(".region").on("click", function () {
    var region = $(this).data("region");
    $(".filter-regions .regions").find(".region").removeClass("active");
    $(this).addClass("active");
    $(".result .item").hide();
    $(".result").find(region).show();
});